import React from 'react';
import { List, Section, SectionSubTitle, Swiper, SwiperSlide, Typography } from 'common/components';
import { METAL_ROOF_INFO_PRODUCTS_LIST } from './metal-roof-info-constants';
import {
  metalRoofInfoList,
  metalRoofProductSlide,
  metalRoofInfoSwiper,
  metalRoofInfoText,
  metalRoofInfoWrapper,
} from './meatal-roof-info-styles';

export const MetalRoofInfo = () => (
  <Section>
    <SectionSubTitle margin="s">Подготовим точные расчёты&nbsp;&mdash; бесплатно!</SectionSubTitle>
    <div className={metalRoofInfoWrapper}>
      <Typography className={metalRoofInfoText} size="body_long" variant="m">
        Мы&nbsp;учтём все необходимые материалы для вашего проекта и&nbsp;подготовим подробную смету
        на&nbsp;товары с&nbsp;расчётом стоимости монтажа. А&nbsp;проверенная бригада от&nbsp;наших партнёров
        сделает все работы под ключ:
      </Typography>

      <List className={metalRoofInfoList} listStyle="disc">
        <li>
          <Typography variant="m" size="body_long">
            замеры
          </Typography>
        </li>
        <li>
          <Typography variant="m" size="body_long">
            демонтаж старой кровли
          </Typography>
        </li>
        <li>
          <Typography variant="m" size="body_long">
            утепление и&nbsp;гидроизоляция
          </Typography>
        </li>
        <li>
          <Typography variant="m" size="body_long">
            монтаж новой кровли
          </Typography>
        </li>
      </List>

      <Typography size="body_long" variant="m" color="text-secondary">
        Доступность услуг можно уточнить онлайн или в&nbsp;магазине.
      </Typography>
    </div>

    <SectionSubTitle as="h3" variant="h3" margin="s">
      Сделаем крышу надёжной и&nbsp;функциональной
    </SectionSubTitle>
    <Swiper
      breakpoints={{
        768: { enabled: false },
      }}
      className={metalRoofInfoSwiper}
      slidesPerView="auto"
      watchOverflow>
      {METAL_ROOF_INFO_PRODUCTS_LIST.map(({ alt, src, title }) => (
        <SwiperSlide className={metalRoofProductSlide}>
          <img alt={alt} src={src} width={144} height={144} />
          <Typography variant="m" size="subtitle">
            {title}
          </Typography>
        </SwiperSlide>
      ))}
    </Swiper>
  </Section>
);
